import { Helmet } from 'react-helmet-async';
import AddCandidateView from 'src/sections/candidates/view/add-candidate-view';
// ----------------------------------------------------------------------

export default function AddCandidate() {
  return (
    <>
      <Helmet>
        <title>Hireintel - Dashboard - Add Candidate</title>
      </Helmet>

      <AddCandidateView />
    </>
  );
}
